import vue from 'vue';
import vuex from 'vuex';
import goods from '@/store/goods';
import user from '@/store/user';
import joinUs from '@/store/joinus';
import thesis from '@/store/thesis';
import onlineDefense from '@/store/onlineDefense';
import faceRecognition from "@/store/faceRecognition";
import APIDOC from '@/common/serverApi';
import {get, post} from '@/common/request';
import VueCookies from 'vue-cookies';
import {getCookieForRoleTag, getStorageKeyForRoleTag} from "../common/ulit";
import getPayConfigSyncFunc from "../utils/usePayStatus";

vue.use(VueCookies);
vue.use(vuex);
const userInfo = JSON.parse(window.sessionStorage.getItem(getStorageKeyForRoleTag('jlw_slug_USERINFO')));
// const token = vue.prototype.$cookies.get("JT_S_02_token");
const token = getCookieForRoleTag();


// vuex
export default new vuex.Store({
    state: {
        // 页面位置，用于返回的时候，重新回到该位置
        position: 0,
        carsTotal: 0,
        ajaxLoad: false,
        ajaxEnd: false,
        carNum: 0,
        showNav: true,
        havBg: false,
        userInfo: userInfo || {},
        token: token,
        "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null,

        share: {
            distributionMemberId: '',
            shareTime: ''
        },
        payConfig:{}
    },
    mutations: {
        STARTREQUEST(state) {
            state.ajaxLoad = true;
            state.ajaxEnd = false;
        },
        ENDREQUEST(state) {
            state.ajaxLoad = false;
            state.ajaxEnd = true;
        },
        CARINFO(state, payload) {
            state.carNum = payload.data;
        },
        TOGGLENAV(state, payload) {
            state.showNav = payload;
        },
        HAVBG(state, payload) {
            state.havBg = payload;
        },
        USERINFO(state, payload) {
            state.userInfo = payload;
        },
        TOKEN(state, payload) {
            state.token = payload;
        },
        SAVE_POSITION(state, payload) {
            state.position = payload;
        },
        setPayStatus(state,payload){
            state.payConfig = payload;
        },

    },
    getters: {
        getUserInfo(state) {
            return state.userInfo;
        },
        getToken(state) {
            return state.token;
        },
        getPayConfig(state){
            return state.payConfig;
        }
    },
    actions: {
        //用户支付状态，决定是否允许四种权限操作。例如：未交费不允许进入学习
        getPayConfigStatus({commit}){
                commit('ENDREQUEST');
            return new Promise((resolve, reject) => {
                getPayConfigSyncFunc().then(res => {//支付配置
                    commit('setPayStatus',res);
                    resolve(res);
                }).catch(err=>{
                    reject(err);
                }).finally(()=>{
                    commit('ENDREQUEST');
                })

            });
        },
        // 密码登录
        getPasswordLogin({commit}, payload) {
            commit('STARTREQUEST');
            return new Promise((resolve, reject) => {
                post(APIDOC.LOGIN.passwordLogin, payload)
                    .then(ret => {
                        commit('ENDREQUEST');
                        resolve(ret);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST');
                        reject(err);
                    });
            });
        },
        // 首页
        getIndex({commit}, payload) {
            commit('STARTREQUEST');
            return new Promise((resolve, reject) => {
                get(APIDOC.INDEX.getHomePageInfo, payload)
                    .then((ret) => {
                        commit('ENDREQUEST');
                        resolve(ret);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST');
                        reject(err);
                    });
            });
        },
        // 获取系统时间
        getNowTime({commit}, payload) {
            commit('STARTREQUEST');
            return new Promise((resolve, reject) => {
                get(APIDOC.LOGIN.getNowTime, payload)
                    .then((ret) => {
                        commit('ENDREQUEST');
                        resolve(ret);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST');
                        reject(err);
                    });
            });
        },
    },
    modules: {
        goods,
        user,
        joinUs,
        faceRecognition,
        thesis,
        onlineDefense
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js